"use client";

import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { safeLogEvent } from "@/libs/shared/analytics/safeLogEvent";
import { useAnalyticsContext } from "@/libs/shared/analytics/AnalyticsProvider";
import { setMessageHandler } from "@/libs/shared/messages/messages.slice";
import { useRegisterMutation } from "@/libs/auth/redux/auth.api";

const useRegister = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const analytics = useAnalyticsContext();
  const [register, { isLoading, error, isSuccess }] = useRegisterMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      dispatch(
        setMessageHandler({
          title: t("Signup:error:title"),
          type: "error",
        }),
      );
    } else if (isSuccess) {
      safeLogEvent(analytics, "registration");
    }
  }, [analytics, dispatch, error, isSuccess, router, t]);

  return {
    register,
    isLoading,
    isSuccess,
  };
};

export default useRegister;
